import { ArrowRight } from "lucide-react";

// Renders block-based article content.
export const ArticleBlocks = ({ blocks = [] }) => (
  <div className="space-y-6">
    {blocks.map((b, i) => {
      if (b.type === "h")
        return (
          <h2 key={i} className="pt-4 font-heading text-2xl font-bold tracking-tight text-brand-ink">
            {b.text}
          </h2>
        );
      if (b.type === "p")
        return (
          <p key={i} className="text-[17px] leading-relaxed text-brand-ink/85">
            {b.text}
          </p>
        );
      if (b.type === "list")
        return (
          <ul key={i} className="space-y-2.5">
            {b.items.map((it, j) => (
              <li key={j} className="flex gap-3 text-[17px] leading-relaxed text-brand-ink/85">
                <ArrowRight className="mt-1.5 h-4 w-4 shrink-0 text-brand-red" />
                <span>{it}</span>
              </li>
            ))}
          </ul>
        );
      if (b.type === "quote")
        return (
          <blockquote
            key={i}
            className="border-l-2 border-brand-red bg-white px-6 py-5 font-heading text-xl font-medium leading-snug text-brand-ink"
          >
            {b.text}
          </blockquote>
        );
      if (b.type === "note")
        return (
          <div key={i} className="border border-brand-blue/20 bg-brand-blue/5 px-6 py-4 text-[15px] leading-relaxed text-brand-blue">
            {b.text}
          </div>
        );
      if (b.type === "table")
        return (
          <div key={i} className="max-w-full overflow-x-auto border border-brand-line">
            <table className="w-full min-w-[560px] border-collapse text-left text-sm">
              {b.head && (
                <thead>
                  <tr className="bg-brand-ink text-white">
                    {b.head.map((h, j) => (
                      <th key={j} className="px-4 py-3 font-heading text-xs font-semibold uppercase tracking-wide">
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
              )}
              <tbody>
                {b.rows.map((row, ri) => (
                  <tr key={ri} className="border-t border-brand-line odd:bg-white even:bg-brand-bg last:font-semibold last:text-brand-ink">
                    {row.map((cell, ci) => (
                      <td key={ci} className={`px-4 py-3 align-top text-brand-ink/85 ${ci === 0 ? "font-medium text-brand-ink" : ""}`}>
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      if (b.type === "flow")
        return (
          <div key={i} className="flex flex-wrap items-center gap-2 border border-brand-line bg-white p-5">
            {b.steps.map((s, j) => (
              <span key={j} className="flex items-center gap-2">
                <span className="border border-brand-line bg-brand-bg px-3 py-1.5 font-mono text-xs font-medium text-brand-ink">
                  {s}
                </span>
                {j < b.steps.length - 1 && <ArrowRight className="h-3.5 w-3.5 text-brand-muted" />}
              </span>
            ))}
          </div>
        );
      return null;
    })}
  </div>
);
